import React from 'react';
import './styles/Home.css'
import { Container, Card, CardContent, CardMedia, Typography } from '@mui/material';
import { Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import quickchart from '../res/images/quickchart.webp';
import gde from '../res/images/gde.webp';
import tm from '../res/images/tm19_1.webp';

function Home(props) {

    let navigate = useNavigate();

    return (
        <Container maxWidth='xl' className="home" >
            <Grid container spacing={1} style={{ padding: '10px' }}>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                    <Card elevation={5} className='card' sx={{ 'minHeight': '250px' }} onClick={(e) => { navigate('quickchart') }} >
                        <CardMedia
                            component="img"
                            // height="140"
                            image={quickchart}
                            alt="QC"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                                Quick Chart
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                A Tool to Enter Special Charecters in Text
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                    <Card elevation={5} className='card' sx={{ 'minHeight': '250px' }} onClick={(e) => { navigate('gde') }}>
                        <CardMedia
                            component="img"
                            // height="140"
                            image={gde}
                            alt="GDE"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                                Guided Document Editor
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                A Guided Document Editor Which Gives More Time To Think About Content
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                    <Card elevation={5} className='card' sx={{ 'minHeight': '250px' }} onClick={(e) => { navigate('tm') }} >
                        <CardMedia
                            component="img"
                            // height="140"
                            image={tm}
                            alt="TM"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                                Thinmatrix Py
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Python3 Implimentation of thinmatrix OpenGL Tutorial.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}

export default Home;
